import { Box, Typography } from '@mui/material';
import { formatterPTY } from '../../../../utils/utils';

const DataGridTotalFooterColocacionDiaria = ({ total, donacionTotal }) => {
    const isFundraising = Boolean(donacionTotal);

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: isFundraising
                    ? '2fr 1fr 1fr 1fr'
                    : '2fr 1fr 1fr',
                width: '100%',
                paddingY: 1,
                // paddingX: 2,
                boxSizing: 'border-box',
                backgroundColor: '#fff',
            }}
        >
            <Typography fontWeight="bold">Total</Typography>
            <Box /> {/* Espacio para Ciudad */}
            <Typography fontWeight="bold">{total}</Typography>
            {isFundraising && (
                <Typography fontWeight="bold">
                    {formatterPTY.format(donacionTotal)}
                </Typography>
            )}
        </Box>
    );
};

export default DataGridTotalFooterColocacionDiaria;
